import { Card, Radio } from 'antd'
import React from 'react'
import { SelectionCardItemHolder } from './Styles/selectionCardItemStyle';
import Text from 'antd/lib/typography/Text';


const SelectionCardItemComponent = ({title, description, checked, onClick}) => {
  return (
    <SelectionCardItemHolder checked={checked} onClick={onClick}>
        <div style={{ display: 'flex', gap: '16px' }}>
            <div>
                <Radio checked={checked}/>
            </div>
            <div>
                <h3>{title}</h3>
                <Text type="secondary">{description}</Text>
            </div>
        </div>
    </SelectionCardItemHolder>
  )
}

export default SelectionCardItemComponent